// BookTickets/SummaryBox/SummaryHeader.tsx
import React from 'react'
import cn from 'classnames'
import styles from '../index.module.scss'
import { useTranslations } from 'next-intl'

export const SummaryHeader = ({
  open,
  onToggleOpen,
}: {
  open: boolean
  onToggleOpen: () => void
}) => {
  const t = useTranslations('booking')
  return (
    <div className={cn(styles.summaryHeader, open && styles.open)} onClick={onToggleOpen}>
      <h3>{t('ticket.summaryBox.title')}</h3>
    </div>
  )
}
